export default class DevicesService {

  static isAllowEdit = true;
}